<template>
  <div class="padding-20 detail-container">
    <div @click="router.back()">
      <i class="el-icon-arrow-left"></i>
      <span class="color-333 pointer">返回</span>
    </div>

    <DriverInfo
      v-loading="driverInfoLoading"
      element-loading-text="正在加载中～"
      @situationDetail="situationDetail"
      @refreshData="getDetail"
    />

    <div class="box margin-bottom-20">
      <OrderInfoSearch />
      <OrderInfoTable @orderDetail="orderDetail" @situationDetail="situationDetail" />
    </div>

    <div class="box" style="max-height: 450px; margin-bottom: 20px">
      <ComplaintTable @complaintDetai="complaintDetai" />
    </div>

    <Situation ref="situation" />
    <OrderInfo ref="orderInfo" />
  </div>
</template>

<script >
import router from '@/router/router';
import DriverInfo from './components/driver-info.vue';
import { provide, ref, onMounted, computed } from '@vue/composition-api';
import { useTableList } from '@/hooks';
import { detail, orderPage, complaint } from '@/api/data-analysis';
import OrderInfoSearch from './components/order-info-search.vue';
import OrderInfoTable from './components/order-info-table.vue';
import ComplaintTable from './components/complaint-table.vue';
import Situation from './components/situation-detail.vue';
import OrderInfo from '@/views/order/ferry/order-info.vue';
import { formatDate } from './util/format-date';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const situation = ref();
  const driverInfo = ref({});
  const driverInfoLoading = ref(false);
  const orderInfo = ref();
  const orderData = ref({});
  const driverId = computed(() => {
    const {
      id = ''
    } = router.currentRoute.params || {};
    return id;
  });
  const initParams = {
    driverId: driverId.value
  };
  onMounted(() => {
    const {
      year,
      month,
      day
    } = formatDate(new Date());
    const result = `${year}-${month}-${day}`;
    initParams.date = [result, result];
    initParams.startDate = initParams.endDate = result;
    getDetail();
  });
  const getDetail = async () => {
    try {
      driverInfoLoading.value = true;
      const {
        code,
        data
      } = await detail({
        driverId: driverId.value
      });
      if (code !== 0) {
        return;
      }
      driverInfo.value = data;
    } catch (error) {} finally {
      driverInfoLoading.value = false;
    }
  };
  provide('driverInfo', driverInfo);
  provide('driverId', driverId);
  provide('orderData', orderData);
  const {
    loading,
    tableData,
    pageState,
    searchParam,
    handleCurrentChange,
    handleSizeChange,
    search,
    reset
  } = useTableList(orderPage, initParams, true, data => {
    orderData.value = data;
    const {
      page = {}
    } = data || {};
    const result = {
      ...data,
      ...page
    };
    if (result.records && Array.isArray(result.records)) {
      result.records.forEach(it => {
        if (it.operationPoint && Array.isArray(it.operationPoint) && it.operationPoint.length > 3) {
          it.one = it.operationPoint[0];
          it.two = it.operationPoint[1];
          it.three = it.operationPoint[2];
          it.four = it.operationPoint[3];
        }
      });
    }
    return result;
  });
  provide('tableData', tableData);
  provide('pageState', pageState);
  provide('searchParam', searchParam);
  provide('loading', loading);
  provide('search', search);
  provide('reset', reset);
  provide('handleCurrentChange', handleCurrentChange);
  provide('handleSizeChange', handleSizeChange);
  const {
    loading: complaintLoading,
    tableData: complaintTableData,
    pageState: complaintPageState,
    searchParam: complaintSearchParam,
    handleCurrentChange: complaintHandleCurrentChange,
    handleSizeChange: complaintHandleSizeChange,
    search: complaintSearch,
    reset: complaintReset
  } = useTableList(complaint, {
    driverId: driverId.value
  }, false);
  provide('complaintTableData', complaintTableData);
  provide('complaintPageState', complaintPageState);
  provide('complaintSearchParam', complaintSearchParam);
  provide('complaintLoading', complaintLoading);
  provide('complaintSearch', complaintSearch);
  provide('complaintReset', complaintReset);
  provide('complaintHandleCurrentChange', complaintHandleCurrentChange);
  provide('complaintHandleSizeChange', complaintHandleSizeChange);
  const orderDetail = row => {
    row.ferryOrderNo = row.orderNo;
    orderInfo.value.init(row);
  };
  const situationDetail = row => {
    situation.value.init(row);
  };
  const complaintDetai = row => {
    const url = '/customer/complaint/detail?id=' + row.id;
    window.open(url);
  };
  return {
    router,
    situation,
    driverInfoLoading,
    orderInfo,
    getDetail,
    orderDetail,
    situationDetail,
    complaintDetai
  };
};
__sfc_main.components = Object.assign({
  DriverInfo,
  OrderInfoSearch,
  OrderInfoTable,
  ComplaintTable,
  Situation,
  OrderInfo
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="scss" scoped>
  .detail-container {
    background: #f1f2f5;
    box-sizing: border-box;
    min-height: calc(100vh - 96px);
  }
  .box {
    max-height: 600px;
    background: #fff;
    padding: 15px 20px;
    border-radius: 8px;
    // box-sizing: border-box;
  }
</style>
